module.exports = __webpack_public_path__ + "static/nodejs-6dcf699938b2291d1634f91adb0dded1.png";